import React from 'react'
import { ModalFormId } from 'src/components/ModalForms'
import { useModalState } from 'src/Modal/ModalStateContext'
import { EditSVG } from 'src/components/Icons/Basic'
import styled from 'styled-components/macro'
import { PERMISSIONS } from 'src/config/roleConfig'
import { useHasRequiredPermissions } from 'src/app/AppAuth/AppAuth.hooks'
import { SimpleIconButton } from '../../Buttons/SimpleIconButton'

const GridColumnEditIcon = styled(EditSVG)`
  height: 16px;
  width: 16px;
  margin: 5px;
`

export const GridColumnEdit = ({
  modalId,
  permissions,
}: {
  modalId: ModalFormId
  permissions: PERMISSIONS[]
}): JSX.Element | null => {
  const { openModal } = useModalState()
  const hasPermission = useHasRequiredPermissions(permissions)

  if (!hasPermission) {
    return null
  }

  return (
    <SimpleIconButton
      onClick={() => {
        openModal(modalId)
      }}
    >
      <GridColumnEditIcon />
    </SimpleIconButton>
  )
}
